import { useQuery } from "@tanstack/react-query";
import axiosInstance from "./axiosInstanse";
import { enum_api_uri } from "../utils/enum";

interface BillItem {
    num: string;
    s_Date: string;
    송장번호: string;
    출발지: string;
    도착지: string;
    구분: string;
    담당자: string;
    수량: number;
    월정료: number;
    금액: number;
    추가금액: number;
    합계: number;
    메모: string;
}

interface SumList {
    s_p_code: string;
    C_Month_YN: string;
    C_Feat_Date: string;
    C_Comp_kind: string;
    c_company: string;
    s_p_dept: string;
    dept_name: string;
    c_fax: string;
    email: string;
    req_moble: string;
    월정료: number;
    추가할인: number;
    공급가액: number;
    합계: number;
    부가세: number;
    총합계: number;
}

interface CompanyInfo {
    shop_name: string;
    saup_no: string;
    tel_no: string;
    addr: string;
    homepage: string;
    bank_info: string;
    bank_info2: string;
    bank_info3: string | null;
}

interface Dept {
    sn: number;
    dept_name: string;
}

export interface BillListResponse {
    limit: number;
    current_page: number;
    start_page: number;
    max_page: number;
    last_page: number;
    end_page: number;
    total_count: number;
    billList: BillItem[];
    sumList: SumList;
    companyInfo: CompanyInfo;
    yyyy: string;
    mm: string;
    startDate: string;
    endDate: string;
    dept: Dept[];
}

export interface BillListRequest {
    getPage: string;
    getPageSize: string;
    flag: string;
    yyyy?: string;
    mm?: string;
    startDate?: string;
    endDate?: string;
    s_p_dept?: string;
    et_code?: string;
}

export const usePostBillList = (requestData: BillListRequest) => {
    return useQuery({
        queryKey: ["usePostBillList", requestData],
        queryFn: async () => {
            const response = await axiosInstance.post<{ statusCode: number; message: string; data: BillListResponse }>(
                enum_api_uri.bill_list,
                requestData,
            );
            return response.data.data;
        },
        enabled: !!requestData,
        placeholderData: prevData => prevData,
    });
};
